import requests from '../requests.js';

const state = {
  list: {},
  open: null,
  participants: {},
};

const getters = {
  /**
   * Return the open project (may not be on the list)
   * @returns {string}
   */
  getOpen(state) {
    return state.open;
  },
};

const actions = {
  /**
   * Set the name of the specified project
   * @param {string} value  The new name
   * @param {string} hash   The project
   */
  setName(context, { value, hash }) {
    // Notify the project store
    if (context.getters.getOpen === hash) {
      context.commit('project/setName', { value }, { root: true });
    }
  },

  /**
   * Update the project name of the specific project
   * @param {string} hash   The project hash
   * @param {string} name   The new project name
   */
  updateName(context, { hash, name }) {
    return requests.projects.updateName({ hash, name }).then(response => {
      context.dispatch('setName', { value: name, hash });
      return Promise.resolve(response);
    });
  },

  /**
   * Create a new project and reload the list of projects
   */
  async createProject(context, { template }) {
    context.commit(
      'application/appStates/setIsProjectCreating',
      { value: true, template },
      { root: true }
    );

    return requests.projects.createProject({ template }).then(() => {
      return context.dispatch('loadProjects', {}, { root: true }).then(resp => {
        context.commit(
          'application/appStates/setIsProjectCreating',
          { value: false, template: null },
          { root: true }
        );
        return Promise.resolve(resp);
      });
    });
  },

  /**
   * Delete a given project (logically)
   */
  deleteProject(context, { hash }) {
    return requests.projects.deleteProject({ hash }).then(response => {
      const { error } = response.data;
      if (!error) {
        context.dispatch('loadProjects', {}, { root: true });
      }
      return Promise.resolve(response);
    });
  },
};

const mutations = {
  /**
   * Set the state projects to the given one
   * @param {Object} list  The projects
   * @param {String} open  The open project
   * @param {Object} participants  The participants
   */
  setProjects(state, { list, open, participants }) {
    state.list = list;
    state.open = open;
    state.participants = participants;
  },

  /**
   * Set whether a project is public or not
   * @param {string|null} value The new value
   * @param {string}      hash  The project
   */
  setPublicLink(state, { value, hash }) {
    state.list[hash].publicLink = value;
  },

  /**
   * Set the open project
   * @param {string} hash The open project
   */
  setOpen(state, { hash }) {
    state.open = hash;
  },

  /**
   * Add a new participant data.
   * @param {string}  hash
   * @param {Object}  user
   */
  addParticipant(state, { user }) {
    state.participants[user.id] = user;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
